import request from '@/utils/request'

const base = '/erp/finance/document'

export const listFinanceDocuments = params => request({ url: `${base}/page`, method: 'get', params })
export const getFinanceDocument = id => request({ url: `${base}/detail`, method: 'get', params: { id } })
export const listFinanceSources = params => request({ url: `${base}/sources`, method: 'get', params })
export const listFinanceParties = params => request({ url: `${base}/parties`, method: 'get', params })
export const saveFinanceDocument = data => request({ url: `${base}/save`, method: 'post', data })
export const auditFinanceDocument = id => request({ url: `${base}/audit`, method: 'post', data: { id } })
export const reverseFinanceDocument = id => request({ url: `${base}/reverse-audit`, method: 'post', data: { id } })
export const voidFinanceDocument = id => request({ url: `${base}/void`, method: 'post', data: { id } })
export const deleteFinanceDocument = id => request({ url: `${base}/delete`, method: 'post', data: { id } })

const cashAccountBase = '/erp/finance/cash-account'
export const listFinanceCashAccounts = params => request({ url: `${cashAccountBase}/list`, method: 'get', params })
export const saveFinanceCashAccount = data => request({ url: `${cashAccountBase}/save`, method: 'post', data })
export const updateFinanceCashAccountStatus = data => request({ url: `${cashAccountBase}/status`, method: 'post', data })

export const pagePaymentFlow = params => request({ url: '/erp/finance/payment-flow/page', method: 'get', params })
